function validateCellReg(cell) {
    var re = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
    // para solo Chile
    // var re = /^(\+?56)?(\s?)(0?9)(\s?)[9876543]\d{7}$/;
    return re.test(cell);
  }
  

if (document.querySelector('.input-box-dekaz.cellphone')) {
    const lang = document.documentElement.lang
    let textError = ''
    if (lang === 'es' || lang === 'es-CL') {
        textError = 'Este campo no es un Celular valido, usa el formato +56xxxxx'
      } else {
        textError = 'This field is not a valid Cell phone, use the format + 56xxxxx'
      }
    const inputGroups = document.querySelectorAll('.input-box-dekaz.cellphone')
    inputGroups.forEach(inputGroup => {
        //   inputGroup  
        const inp = inputGroup.querySelector('input')
        const error = inputGroup.nextElementSibling
        // console.log(inp)
        if (inp) {
            inp.addEventListener('keyup', (e) => {
                // console.log(inp.value)

                if(inp.value === ''  || !validateCellReg(inp.value)) {
                    error.classList.add('active')
                    inputGroup.classList.add('invalid')
                    error.innerHTML = textError
                } else {
                    error.classList.remove('active')
                    inputGroup.classList.remove('invalid')
                }
            })
        }

    })
}

export function validateCell(form){
    const inputGroups = form.querySelectorAll('.input-box-dekaz.cellphone')
    let errorEx = false
    if(inputGroups){
        let textError = ''
        const lang = document.documentElement.lang
        if (lang === 'es' || lang === 'es-CL') {
            textError = 'Este campo no es un celular valido'
          } else {
            textError = 'This field is not a valid Cell phone, use the format + 56xxxxx'
          }

    inputGroups.forEach(inputGroup => {
        //   inputGroup  
        const inp = inputGroup.querySelector('input')
        const error = inputGroup.nextElementSibling
        if(inp.value === ''  || !validateCellReg(inp.value)) {
            error.classList.add('active')
            inputGroup.classList.add('invalid')
            error.innerHTML = textError
            errorEx = true
        }
    })
    }
    return errorEx
}

// import {validateCell} from '@/js/components/validation/class/val_cellphone'